// İSG: personeli tarih aralığıyla bloklama (açıklama zorunlu, firmaya e-posta gider)
import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Ban } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const today = () => new Date().toLocaleDateString('sv-SE');

export const BlockEmployeeDialog = ({ employee, onClose, onDone }) => {
  const [start, setStart] = useState(today());
  const [end, setEnd] = useState('');
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  if (!employee) return null;

  const save = async () => {
    setSaving(true);
    try {
      await axios.post(`${API}/employees/${employee.id}/block`, { start_date: start, end_date: end || null, reason });
      toast.success('Personel bloklandı, firmaya e-posta gönderildi');
      onDone();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Bloklama başarısız');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="block-employee-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-rose-700"><Ban className="h-5 w-5" />Personeli Blokla – {employee.name} {employee.surname}</DialogTitle>
        </DialogHeader>
        <p className="text-xs text-slate-500">Bloklanan kişi bu tarihler arasında hiçbir firmada kaydedilemez, taleplere eklenemez ve belgeleri onaylanamaz. Bitiş tarihinde blok kendiliğinden kalkar.</p>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <Label>Başlangıç *</Label>
            <Input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid="block-start-date" />
          </div>
          <div className="space-y-1">
            <Label>Bitiş (boş = süresiz)</Label>
            <Input type="date" value={end} min={start} onChange={(e) => setEnd(e.target.value)} data-testid="block-end-date" />
          </div>
        </div>
        <div className="space-y-1">
          <Label>Açıklama * <span className="text-[11px] font-normal text-slate-500">(firmaya e-postada iletilir)</span></Label>
          <Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} placeholder="Bloklama nedeni..." data-testid="block-reason" />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="block-cancel">İptal</Button>
          <Button onClick={save} disabled={saving || !start || !reason.trim()} className="bg-rose-600 hover:bg-rose-700" data-testid="block-confirm">Blokla</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

// Talep ekranlarında personel adı: bloklu = kırmızı üstü çizili, arşivde = gri üstü çizili
export const PersonName = ({ person, className = '' }) => {
  const label = `${person.name} ${person.surname}`;
  if (person.is_blocked) return <span className={`text-rose-600 line-through decoration-rose-600 decoration-2 ${className}`} title="Bloklanmıştır" data-testid={`person-blocked-${person.id}`}>{label}</span>;
  if (person.is_archived) return <span className={`text-slate-400 line-through decoration-slate-500 ${className}`} title="Silinmiştir" data-testid={`person-archived-${person.id}`}>{label}</span>;
  return <span className={className}>{label}</span>;
};
